var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0439 7.338C10.5599 7.338 10.9439 7.494 11.1959 7.806C11.4479 8.112 11.5739 8.58 11.5739 9.21V12H10.4489V9.246C10.4489 8.886 10.3889 8.628 10.2689 8.472C10.1549 8.31 9.96287 8.229 9.69287 8.229C9.38087 8.229 9.13487 8.34 8.95487 8.562C8.78087 8.778 8.69387 9.078 8.69387 9.462V12H7.56887V9.246C7.56887 8.892 7.50587 8.634 7.37987 8.472C7.25987 8.31 7.06787 8.229 6.80387 8.229C6.49187 8.229 6.24587 8.34 6.06587 8.562C5.88587 8.778 5.79587 9.078 5.79587 9.462V12H4.67987V8.742C4.67987 8.262 4.65587 7.833 4.60787 7.455H5.66087L5.74187 8.175C5.87387 7.905 6.06287 7.698 6.30887 7.554C6.56087 7.41 6.84887 7.338 7.17287 7.338C7.86887 7.338 8.32187 7.626 8.53187 8.202C8.67587 7.932 8.87987 7.722 9.14387 7.572C9.41387 7.416 9.71387 7.338 10.0439 7.338ZM12.7746 7.455H13.8906V12H12.7746V7.455ZM13.9536 5.394V6.501H12.7026V5.394H13.9536ZM17.7223 7.338C18.8083 7.338 19.3513 7.962 19.3513 9.21V12H18.2263V9.264C18.2263 8.904 18.1573 8.643 18.0193 8.481C17.8813 8.313 17.6683 8.229 17.3803 8.229C17.0383 8.229 16.7623 8.34 16.5523 8.562C16.3423 8.778 16.2373 9.066 16.2373 9.426V12H15.1213V8.742C15.1213 8.262 15.0973 7.833 15.0493 7.455H16.1023L16.1833 8.202C16.3393 7.926 16.5493 7.713 16.8133 7.563C17.0833 7.413 17.3863 7.338 17.7223 7.338Z",
    fill: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMin);
export default __webpack_public_path__ + "static/media/min.bc4446f71d207e9496115199fa9d057c.svg";
export { ForwardRef as ReactComponent };